import { Address } from '@/types/address/address';
import { FieldConfig } from '@/types/forms/field-config';

export const loadAddressFields = (): FieldConfig<keyof Address>[] => {
  return [
    {
      name: 'Direccion',
      label: 'Dirección',
    },
    {
      name: 'CodigoPostal',
      label: 'Código Postal',
    },
    {
      name: 'Numero',
      label: 'Número',
    },
    {
      name: 'Piso',
      label: 'Piso',
    },
    {
      name: 'DireccionComplementaria',
      label: 'Complemento',
    },
    {
      name: 'Municipio',
      label: 'Municipio',
    },
    {
      name: 'Provincia',
      label: 'Provincia',
    },
    {
      name: 'FkPaises',
      label: 'País',
      type: 'select',
    },
  ];
};
